import { Booking } from "../../../state/models";
import { Ancillary, AnciService } from "../../../state/models/Ancillary";


export function getOnlineCheckinSurchargeAmount(ancillaries: Ancillary[]) {
    const checkinSsrs = getOnlineCheckinSsrs(ancillaries);
    return checkinSsrs.length > 0 
      ? checkinSsrs.reduce((a, b) => a + b.amount, 0) 
      : 0;
}

export function hasOnlineCheckinInBooking(booking: Booking): boolean {
  const logicalFlightId = Array.isArray(booking?.segments) && booking.segments.length > 0 ?  booking.segments[0].logicalFlightId : 0;
  if(!logicalFlightId) return false;

  if(!Array.isArray(booking.passengers)) return false;
  return booking.passengers.some(pax => Array.isArray(pax.onlineCheckin) && pax.onlineCheckin.some(c => c.logicalFlightId === logicalFlightId));  
}

function getOnlineCheckinSsrs(ancillaries: Ancillary[]): AnciService[] {

  const result: AnciService[] = [];
  if(!Array.isArray(ancillaries)) return result;

  for(const ancillary of ancillaries) {
    if(!Array.isArray(ancillary?.passengers)) continue;
    const passengers = ancillary.passengers.filter(p => Array.isArray(p.onlineCheckin) && p.onlineCheckin.length > 0);
    if(!passengers.length) continue;
    for(const passenger of passengers) {  
      if(Array.isArray(passenger.onlineCheckin) && passenger.onlineCheckin[0]?.ssrCode)
        result.push(passenger.onlineCheckin[0]); 
    }
  }

  return result
}
